/**
 * GENERATED FILE. Do not edit.
 *
 * Source: packages/shared/registry/components.json
 * Rebuild: bun run registry:build
 */

import type { ComponentId } from './component-ids';
import type { ValueTypeId } from './value-types';

export type PropType = 'string' | 'number' | 'boolean' | 'string[]' | 'field_id' | 'record_id' | 'enum';
export type ComponentCapability = 'filterable' | 'sortable' | 'groupable';

export type PropDecl = {
  readonly type: PropType;
  /** Present only when type is 'enum'. */
  readonly values?: readonly string[];
};

export type ComponentEntry = {
  readonly id: ComponentId;
  /** Bumped on a behaviour change that is not a new prop. */
  readonly version: number;
  /** The lowest REGISTRY_VERSION whose client holds this component. */
  readonly since_registry: number;
  readonly value_types: readonly ValueTypeId[];
  /** Older rungs, most capable first. A primitive has none. */
  readonly fallback: readonly ComponentId[];
  readonly capabilities: readonly ComponentCapability[];
  readonly props: { readonly [key: string]: PropDecl };
};

export const COMPONENTS: { readonly [K in ComponentId]: ComponentEntry } = {
  'text.plain': {
    id: 'text.plain',
    version: 1,
    since_registry: 1,
    value_types: ['text'],
    fallback: [],
    capabilities: ['filterable', 'sortable', 'groupable'],
    props: {
      placeholder_key: { type: 'string' },
      max_length: { type: 'number' },
      autocapitalize: { type: 'enum', values: ['none', 'sentences', 'words', 'characters'] },
    },
  },
  'text.multiline': {
    id: 'text.multiline',
    version: 1,
    since_registry: 1,
    value_types: ['long_text'],
    fallback: [],
    capabilities: ['filterable'],
    props: {
      placeholder_key: { type: 'string' },
      max_length: { type: 'number' },
      rows: { type: 'number' },
    },
  },
  'text.phone': {
    id: 'text.phone',
    version: 1,
    since_registry: 1,
    value_types: ['phone'],
    fallback: [],
    capabilities: ['filterable', 'sortable'],
    props: {
      default_country: { type: 'string' },
      tap_to_call: { type: 'boolean' },
    },
  },
  'number.plain': {
    id: 'number.plain',
    version: 1,
    since_registry: 1,
    value_types: ['number', 'quantity'],
    fallback: [],
    capabilities: ['filterable', 'sortable', 'groupable'],
    props: {
      min: { type: 'number' },
      max: { type: 'number' },
      decimals: { type: 'number' },
      unit_slot_field: { type: 'field_id' },
      unit_list: { type: 'string[]' },
    },
  },
  'number.stepper': {
    id: 'number.stepper',
    version: 1,
    since_registry: 2,
    value_types: ['number', 'quantity'],
    fallback: ['number.plain'],
    capabilities: ['filterable', 'sortable', 'groupable'],
    props: {
      min: { type: 'number' },
      max: { type: 'number' },
      step: { type: 'number' },
      unit_list: { type: 'string[]' },
    },
  },
  'money.calculator': {
    id: 'money.calculator',
    version: 1,
    since_registry: 1,
    value_types: ['money'],
    fallback: [],
    capabilities: ['filterable', 'sortable'],
    props: {
      sign_control: { type: 'boolean' },
      allow_expression: { type: 'boolean' },
      quick_amounts: { type: 'string[]' },
    },
  },
  'date.picker': {
    id: 'date.picker',
    version: 1,
    since_registry: 1,
    value_types: ['date', 'datetime'],
    fallback: [],
    capabilities: ['filterable', 'sortable', 'groupable'],
    props: {
      mode: { type: 'enum', values: ['date', 'datetime'] },
      default: { type: 'enum', values: ['none', 'now', 'today'] },
      min_offset_days: { type: 'number' },
      max_offset_days: { type: 'number' },
    },
  },
  'boolean.switch': {
    id: 'boolean.switch',
    version: 1,
    since_registry: 1,
    value_types: ['boolean'],
    fallback: [],
    capabilities: ['filterable', 'groupable'],
    props: {
      on_label_key: { type: 'string' },
      off_label_key: { type: 'string' },
    },
  },
  'select.chips': {
    id: 'select.chips',
    version: 1,
    since_registry: 1,
    value_types: ['select'],
    fallback: [],
    capabilities: ['filterable', 'groupable'],
    props: {
      multi: { type: 'boolean' },
      allow_search: { type: 'boolean' },
      max_visible: { type: 'number' },
      target_record: { type: 'record_id' },
    },
  },
  'reference.search_picker': {
    id: 'reference.search_picker',
    version: 1,
    since_registry: 1,
    value_types: ['reference'],
    fallback: [],
    capabilities: ['filterable', 'groupable'],
    props: {
      target_record: { type: 'record_id' },
      recent_first: { type: 'boolean' },
      subtitle_lookup: { type: 'field_id' },
      allow_create: { type: 'boolean' },
    },
  },
  'reference.multi_picker': {
    id: 'reference.multi_picker',
    version: 1,
    since_registry: 1,
    value_types: ['multi_select'],
    fallback: [],
    capabilities: ['filterable', 'groupable'],
    props: {
      target_record: { type: 'record_id' },
    },
  },
  'file.picker': {
    id: 'file.picker',
    version: 1,
    since_registry: 1,
    value_types: ['attachment'],
    fallback: [],
    capabilities: ['filterable'],
    props: {
      max_files: { type: 'number' },
      accept: { type: 'string[]' },
      source: { type: 'enum', values: ['any', 'camera', 'library'] },
    },
  },
  'map.picker': {
    id: 'map.picker',
    version: 1,
    since_registry: 1,
    value_types: ['location'],
    fallback: [],
    capabilities: ['filterable'],
    props: {
      default_zoom: { type: 'number' },
      allow_manual: { type: 'boolean' },
    },
  },
  'value.readonly': {
    id: 'value.readonly',
    version: 1,
    since_registry: 1,
    value_types: ['formula', 'rollup', 'lookup'],
    fallback: [],
    capabilities: ['filterable', 'sortable', 'groupable'],
    props: {
      prefix_key: { type: 'string' },
      suffix_key: { type: 'string' },
      decimals: { type: 'number' },
    },
  },
  'lines.table': {
    id: 'lines.table',
    version: 1,
    since_registry: 1,
    value_types: ['lines'],
    fallback: [],
    capabilities: [],
    props: {

    },
  },
};

/** Every component that can read a given value type, in registry order. */
export const COMPONENTS_FOR_VALUE_TYPE: { readonly [K in ValueTypeId]: readonly ComponentId[] } = {
  'text': ['text.plain'],
  'long_text': ['text.multiline'],
  'number': ['number.plain', 'number.stepper'],
  'money': ['money.calculator'],
  'quantity': ['number.plain', 'number.stepper'],
  'date': ['date.picker'],
  'datetime': ['date.picker'],
  'boolean': ['boolean.switch'],
  'select': ['select.chips'],
  'multi_select': ['reference.multi_picker'],
  'reference': ['reference.search_picker'],
  'attachment': ['file.picker'],
  'phone': ['text.phone'],
  'location': ['map.picker'],
  'formula': ['value.readonly'],
  'rollup': ['value.readonly'],
  'lookup': ['value.readonly'],
  'lines': ['lines.table'],
};

/** Props for `text.plain`. Every prop is optional: the component must draw with none. */
export type TextPlainProps = {
  readonly placeholder_key?: string;
  readonly max_length?: number;
  readonly autocapitalize?: 'none' | 'sentences' | 'words' | 'characters';
};

/** Props for `text.multiline`. Every prop is optional: the component must draw with none. */
export type TextMultilineProps = {
  readonly placeholder_key?: string;
  readonly max_length?: number;
  readonly rows?: number;
};

/** Props for `text.phone`. Every prop is optional: the component must draw with none. */
export type TextPhoneProps = {
  readonly default_country?: string;
  readonly tap_to_call?: boolean;
};

/** Props for `number.plain`. Every prop is optional: the component must draw with none. */
export type NumberPlainProps = {
  readonly min?: number;
  readonly max?: number;
  readonly decimals?: number;
  readonly unit_slot_field?: string;
  readonly unit_list?: readonly string[];
};

/** Props for `number.stepper`. Every prop is optional: the component must draw with none. */
export type NumberStepperProps = {
  readonly min?: number;
  readonly max?: number;
  readonly step?: number;
  readonly unit_list?: readonly string[];
};

/** Props for `money.calculator`. Every prop is optional: the component must draw with none. */
export type MoneyCalculatorProps = {
  readonly sign_control?: boolean;
  readonly allow_expression?: boolean;
  readonly quick_amounts?: readonly string[];
};

/** Props for `date.picker`. Every prop is optional: the component must draw with none. */
export type DatePickerProps = {
  readonly mode?: 'date' | 'datetime';
  readonly default?: 'none' | 'now' | 'today';
  readonly min_offset_days?: number;
  readonly max_offset_days?: number;
};

/** Props for `boolean.switch`. Every prop is optional: the component must draw with none. */
export type BooleanSwitchProps = {
  readonly on_label_key?: string;
  readonly off_label_key?: string;
};

/** Props for `select.chips`. Every prop is optional: the component must draw with none. */
export type SelectChipsProps = {
  readonly multi?: boolean;
  readonly allow_search?: boolean;
  readonly max_visible?: number;
  readonly target_record?: string;
};

/** Props for `reference.search_picker`. Every prop is optional: the component must draw with none. */
export type ReferenceSearchPickerProps = {
  readonly target_record?: string;
  readonly recent_first?: boolean;
  readonly subtitle_lookup?: string;
  readonly allow_create?: boolean;
};

/** Props for `reference.multi_picker`. Every prop is optional: the component must draw with none. */
export type ReferenceMultiPickerProps = {
  readonly target_record?: string;
};

/** Props for `file.picker`. Every prop is optional: the component must draw with none. */
export type FilePickerProps = {
  readonly max_files?: number;
  readonly accept?: readonly string[];
  readonly source?: 'any' | 'camera' | 'library';
};

/** Props for `map.picker`. Every prop is optional: the component must draw with none. */
export type MapPickerProps = {
  readonly default_zoom?: number;
  readonly allow_manual?: boolean;
};

/** Props for `value.readonly`. Every prop is optional: the component must draw with none. */
export type ValueReadonlyProps = {
  readonly prefix_key?: string;
  readonly suffix_key?: string;
  readonly decimals?: number;
};

/** Props for `lines.table`. Every prop is optional: the component must draw with none. */
export type LinesTableProps = {
  // This component takes no props.
};

/** The prop shape each component id expects. A client component reads its own row. */
export type ComponentPropsById = {
  readonly 'text.plain': TextPlainProps;
  readonly 'text.multiline': TextMultilineProps;
  readonly 'text.phone': TextPhoneProps;
  readonly 'number.plain': NumberPlainProps;
  readonly 'number.stepper': NumberStepperProps;
  readonly 'money.calculator': MoneyCalculatorProps;
  readonly 'date.picker': DatePickerProps;
  readonly 'boolean.switch': BooleanSwitchProps;
  readonly 'select.chips': SelectChipsProps;
  readonly 'reference.search_picker': ReferenceSearchPickerProps;
  readonly 'reference.multi_picker': ReferenceMultiPickerProps;
  readonly 'file.picker': FilePickerProps;
  readonly 'map.picker': MapPickerProps;
  readonly 'value.readonly': ValueReadonlyProps;
  readonly 'lines.table': LinesTableProps;
};
